import { UpdateCmSheetCertificateOfCoursesRequest } from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetCertificateOfCoursesService = {
  async get(cmSheetId: number, courseId: number): Promise<ArrayBuffer> {
    const response = await httpClient.get<ArrayBuffer>(
      `v1/cm-sheets/${cmSheetId}/courses/${courseId}/certificate`,
      { responseType: "arraybuffer" },
    );

    return response;
  },
  async update(
    cmSheetId: number,
    courseId: number,
    body: UpdateCmSheetCertificateOfCoursesRequest,
  ): Promise<void> {
    await httpClient.put(
      `v1/cm-sheets/${cmSheetId}/courses/${courseId}/certificate`,
      body,
      { contentType: "multipart/form-data" },
    );
  },
  async delete(cmSheetId: number, courseId: number): Promise<void> {
    await httpClient.delete(
      `v1/cm-sheets/${cmSheetId}/courses/${courseId}/certificate`,
    );
  },
};

export default CmSheetCertificateOfCoursesService;
